export const canContinueToSenderData = (cartData) => {

    if (!cartData || !cartData.deliveryData) {
        return false
    }

    if (!cartData?.deliveryData.city || (isLocalDelivery(cartData.deliveryData.city) && !cartData.deliveryData.time)) {
        return false
    }

    return cartData.deliveryData.first_name &&
        cartData.deliveryData.last_name && cartData.deliveryData.phone &&
        cartData.deliveryData.address_1 && cartData.deliveryData.city && cartData.deliveryData.postcode
        && cartData.deliveryData.date
}

export const isLocalDelivery = (city) => {

    if (!city) {
        return false
    }

    return ['novi sad', 'novi sad', 'ns', 'futog', 'veternik'].includes(city.toLowerCase())
}

export const calculateShipping = (method, totalPrice, totalWeight) => {

    if(!method?.settings) {
        return 0
    }

    if(method.settings.cost?.value) {
        return parseFloat(method?.settings?.cost?.value)
    }

    if(method.settings.method_rules) {
        const priceRule = getRuleByConditionId('value', method.settings.method_rules.value)

        if(priceRule) {

            const min = parseFloat(priceRule.conditions[0]?.min)
            const max = parseFloat(priceRule.conditions[0]?.max)

            if(totalPrice >= min && totalPrice <= max) {
                return parseFloat(priceRule.cost_per_order)
            }
        }

        const weightRules = getWeightRules(method.settings.method_rules.value)

        if(weightRules) {

            for(let item of weightRules) {
                const min = parseFloat(item.conditions[0]?.min)
                const max = parseFloat(item.conditions[0]?.max)

                if(totalWeight >= min && totalWeight <= max) {
                    return parseFloat(item.cost_per_order)
                }
            }
        }
    }

    return 0
}

const getRuleByConditionId = (id, items) => {

    for(let item of items) {
        const condition = item.conditions.find(x => x.condition_id === id)

        if(condition) {
            return item
        }
    }

    return undefined
}

const getWeightRules = (items) => {

    let result = []

    for(let item of items) {
        const condition = item.conditions.find(x => x.condition_id === 'weight')

        if(condition) {
            result.push(item)
        }
    }

    return result
}

export const calculatePrice = (products, cart) => {

    let price = 0

    for (let id of Object.keys(cart)) {
        const product = getProductById(products, id)
        const quantity = cart[id]

        if (!product) {
            continue
        }

        price = price + (product.price * quantity)
    }

    return price
}

export const calculateWeight = (products, cart) => {

    let price = 0

    for (let id of Object.keys(cart)) {
        const product = getProductById(products, id)
        const quantity = cart[id]

        if (!product) {
            continue
        }

        price = price + (product.weight * quantity)
    }

    return price
}

export const getProductById = (products, id) => {
    return products.find(x => x.id == id)
}